<qpx-confirmation-dialog
    [title]="
        context.checking()
            ? 'Checking building access'
            : 'We couldn’t check your access'
    "
    status="caution"
    confirmButton="Retry"
    cancelButton="Go to My buildings"
    [confirmDisabled]="context.checking()"
    (confirm)="context.retry()"
    (dismiss)="context.leave()"
>
    @if (context.checking()) {
        <p role="status">Checking building access…</p>
    } @else {
        <p role="alert">
            Your changes are still here. Retry to continue editing.
        </p>
    }
    <p>Going to My buildings will discard any unsaved changes.</p>
</qpx-confirmation-dialog>
